import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class InfoScreen extends Component {

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const {
      info
    } = this.props;

    const {
      message
    } = info;

    return (
      <div className="loader-screen">
        <div className="message">
          {message}
        </div>
      </div>
    );
  }
}

InfoScreen.propTypes = {
  info: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {
      info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      // add: () => dispatch(addSection()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InfoScreen);
